import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  class: "watch-page",
  role: "region",
  "aria-label": "video"
};
const _hoisted_2 = {
  key: 0,
  class: "watch-shell"
};
const _hoisted_3 = {
  class: "player-frame"
};
const _hoisted_4 = {
  class: "watch-meta-card"
};
const _hoisted_5 = {
  class: "watch-title"
};
const _hoisted_6 = {
  class: "watch-actions-row"
};
const _hoisted_7 = {
  class: "watch-performer"
};
const _hoisted_8 = {
  class: "watch-action-buttons"
};
const _hoisted_9 = ["title"];
const _hoisted_10 = {
  class: "share-box"
};
const _hoisted_11 = {
  key: 0,
  class: "program-link-wrap"
};
const _hoisted_12 = ["href"];
const _hoisted_13 = {
  key: 1,
  class: "watch-description"
};
const _hoisted_14 = {
  key: 0,
  class: "program-section"
};
const _hoisted_15 = {
  class: "program-header"
};
const _hoisted_16 = {
  class: "program-table"
};
const _hoisted_17 = {
  class: "program-row-title"
};
const _hoisted_18 = {
  key: 0
};
const _hoisted_19 = {
  key: 1
};
const _hoisted_20 = {
  class: "program-row-composer"
};
const _hoisted_21 = {
  key: 1,
  class: "more-section"
};
const _hoisted_22 = {
  class: "section-header"
};
const _hoisted_23 = {
  class: "section-subtext"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_icon = _resolveComponent("b-icon");
  const _component_VideoPlayer = _resolveComponent("VideoPlayer");
  const _component_b_form_input = _resolveComponent("b-form-input");
  const _component_b_button = _resolveComponent("b-button");
  const _component_b_input_group_append = _resolveComponent("b-input-group-append");
  const _component_b_input_group = _resolveComponent("b-input-group");
  const _component_b_collapse = _resolveComponent("b-collapse");
  const _component_GridItem = _resolveComponent("GridItem");
  const _component_b_col = _resolveComponent("b-col");
  const _component_b_row = _resolveComponent("b-row");
  const _component_b_overlay = _resolveComponent("b-overlay");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_b_overlay, {
    show: $data.loading || !$props.video || !$props.video.id || $data.videoOptions.sources.length === 0,
    rounded: "lg",
    opacity: "0.6",
    "spinner-variant": "primary",
    class: "watch-overlay"
  }, {
    default: _withCtx(() => [$props.video && $props.video.id && $data.videoOptions.sources.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("button", {
      class: "back-nav-btn",
      type: "button",
      onClick: _cache[0] || (_cache[0] = (...args) => $options.clearVideo && $options.clearVideo(...args))
    }, [_createVNode(_component_b_icon, {
      icon: "arrow-left"
    }), _cache[4] || (_cache[4] = _createElementVNode("span", null, "Back to Video List", -1))]), _createElementVNode("div", _hoisted_3, [(_openBlock(), _createBlock(_component_VideoPlayer, {
      key: $props.video.id,
      options: $data.videoOptions,
      viewedInterval: 30,
      updateInterval: 30,
      id: $props.video.id
    }, null, 8, ["options", "id"]))]), _createElementVNode("div", _hoisted_4, [_createElementVNode("h1", _hoisted_5, _toDisplayString($props.video.video.title), 1), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_cache[5] || (_cache[5] = _createTextVNode(" Performed by: ", -1)), _createElementVNode("strong", null, _toDisplayString($options.performerLabel), 1)]), _createElementVNode("div", _hoisted_8, [_createElementVNode("button", {
      type: "button",
      class: _normalizeClass(["watch-action-btn", {
        favorited: $data.localFavorite
      }]),
      onClick: _cache[1] || (_cache[1] = (...args) => $options.favorite && $options.favorite(...args)),
      title: $data.localFavorite ? 'Remove Favorite' : 'Add Favorite'
    }, [_createVNode(_component_b_icon, {
      icon: $data.localFavorite ? 'heart-fill' : 'heart'
    }, null, 8, ["icon"])], 10, _hoisted_9), _createElementVNode("button", {
      type: "button",
      class: "watch-action-btn",
      onClick: _cache[2] || (_cache[2] = (...args) => $options.toggleShare && $options.toggleShare(...args)),
      title: "Share video"
    }, [_createVNode(_component_b_icon, {
      icon: "share-fill"
    })])])]), _createVNode(_component_b_collapse, {
      modelValue: $data.sharebox,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.sharebox = $event),
      class: "share-collapse"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_10, [_createVNode(_component_b_input_group, null, {
        default: _withCtx(() => [_createVNode(_component_b_form_input, {
          value: $props.video.shareableLink,
          readonly: ""
        }, null, 8, ["value"]), _createVNode(_component_b_input_group_append, null, {
          default: _withCtx(() => [_createVNode(_component_b_button, {
            variant: "primary",
            onClick: $options.copy
          }, {
            default: _withCtx(() => [_createVNode(_component_b_icon, {
              icon: "clipboard"
            })], undefined, true),
            _: 1
          }, 8, ["onClick"])], undefined, true),
          _: 1
        })], undefined, true),
        _: 1
      })])], undefined, true),
      _: 1
    }, 8, ["modelValue"]), $props.video.video.programlink && $props.video.video.programlink !== '' ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createElementVNode("a", {
      href: $props.video.video.programlink,
      target: "_blank",
      class: "program-link"
    }, " View Program → ", 8, _hoisted_12)])) : _createCommentVNode("", true), $props.video.video.description && $props.video.video.description.length ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_cache[6] || (_cache[6] = _createElementVNode("strong", null, "Description :", -1)), _createTextVNode(" " + _toDisplayString($props.video.video.description), 1)])) : _createCommentVNode("", true)]), $props.video.video.ownVideocomposition && $props.video.video.ownVideocomposition.length ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createVNode(_component_b_icon, {
      icon: "list-ul"
    }), _cache[7] || (_cache[7] = _createElementVNode("span", null, "Program", -1))]), _createElementVNode("div", _hoisted_16, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.video.video.ownVideocomposition, vc => {
      return _openBlock(), _createElementBlock("div", {
        key: vc.id,
        class: "program-row"
      }, [_createElementVNode("div", _hoisted_17, [vc.composition_id > 0 && vc.composition ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(vc.composition.title), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(vc.newtitle), 1))]), _createElementVNode("div", _hoisted_20, [vc.composition && vc.composition.sharedComposer && vc.composition.sharedComposer.length ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createTextVNode(_toDisplayString(vc.composition.sharedComposer.map(c => c.name).join(", ")), 1)], 64)) : vc.newcomposer ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createTextVNode(_toDisplayString(vc.newcomposer), 1)], 64)) : _createCommentVNode("", true)])]);
    }), 128))])])) : _createCommentVNode("", true), $options.moreFromChannel.length ? (_openBlock(), _createElementBlock("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createElementVNode("div", null, [_cache[8] || (_cache[8] = _createElementVNode("h2", {
      class: "section-title"
    }, "More from This Channel", -1)), _createElementVNode("div", _hoisted_23, _toDisplayString($options.moreFromChannel.length) + " videos ", 1)])]), _createVNode(_component_b_row, {
      class: "more-video-row"
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.moreFromChannel, item => {
        return _openBlock(), _createBlock(_component_b_col, {
          key: item.id,
          cols: "12",
          sm: "6",
          md: "4",
          lg: "3",
          class: "more-video-col"
        }, {
          default: _withCtx(() => [_createVNode(_component_GridItem, {
            video: item,
            preview: false,
            onPlay: $event => $options.playRelated(item.id),
            onUpdateVideoFavoriteStatus: $options.updateRelatedFavoriteStatus
          }, null, 8, ["video", "onPlay", "onUpdateVideoFavoriteStatus"])], undefined, true),
          _: 2
        }, 1024);
      }), 128))], undefined, true),
      _: 1
    })])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)], undefined, true),
    _: 1
  }, 8, ["show"])]);
}